import { Link, useLocation } from 'react-router-dom';
import { Button, Divider } from '@ds';

type SchedulerSettingsSubmitRowProps = {
  isReadOnly?: boolean;
  backPath: string;
  isLoading?: boolean;
};

export const SchedulerSettingsSubmitRow = ({
  isReadOnly = false,
  backPath,
  isLoading,
}: SchedulerSettingsSubmitRowProps) => {
  const { state } = useLocation();
  const discardPath = state ? `${backPath}?${new URLSearchParams(state).toString()}` : backPath;

  return (
    <div className="flex justify-end flex-col mt-4 sticky bottom-0 bg-base-70 z-10">
      <Divider />
      <div className="flex gap-3 self-end my-5 pr-14">
        <Button variant="outline" size="sm" as={Link} to={discardPath} className="min-w-[130px]">
          Discard
        </Button>
        <Button size="sm" type="submit" className="min-w-[130px]" isLoading={isLoading} isDisabled={isReadOnly}>
          Save
        </Button>
      </div>
    </div>
  );
};
